// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + {"53":"profil","224":"register","341":"duo","573":"mackerprod","884":"admin","943":"studee"}[chunkId] + "." + {"53":"f5fb38f5","224":"f13b9bad","341":"c9c65fda","573":"3504621a","884":"22023506","943":"de3b3a57"}[chunkId] + ".css";
};